import { useAnexoDialog } from "./use-anexo-dialog";
import { AnexoDialogView } from "./view-anexo-dialog";
import type { AnexoDialogProps } from "./types-anexo-dialog";

export function AnexoDialog(props: AnexoDialogProps) {
  const vm = useAnexoDialog(props);

  return <AnexoDialogView {...vm} />;
}

export type * from "./types-anexo-dialog";
